import { CYCLE_COUNTERS } from '../globals';
import { TIsPartOfACycleFunction } from '../types';

export const isPartOfACycle: TIsPartOfACycleFunction = (audioNode) => {
    return CYCLE_COUNTERS.has(audioNode);
};
